"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineBulkAction = defineBulkAction;
function defineBulkAction(action) {
    return action;
}
